import http from "./httpService";

const apiEndpoint = "/config-center";

function storeConfigsUrl(location) {
  return `${apiEndpoint}/store-configs/${encodeURIComponent(location)}/`;
}

function inferenceConfigsUrl() {
  return `${apiEndpoint}/inference-configs/`;
}

export function getStoreConfig(location) {
  return http.get(storeConfigsUrl(location));
}

/**
 * Refresh store config from the CRM.
 * POST /api/config-center/store-configs/{location}/refresh-from-crm/
 * @param {string} location - Store id (e.g. store.location)
 * @returns {Promise} 200: { data: full store config }; 404/503 throw with response
 */
export function refreshStoreFromCrm(location) {
  return http.post(`${storeConfigsUrl(location)}refresh-from-crm/`);
}

/**
 * Force a store to active status.
 * POST /api/config-center/store-configs/{location}/force-active/
 * @param {string} location - Store id (e.g. store.location)
 * @returns {Promise} 200: { data: StoreFullConfig }
 */
export function forceActiveStore(location) {
  return http.post(`${storeConfigsUrl(location)}force-active/`);
}

/**
 * Remove forced-active override and re-sync from the CRM.
 * DELETE /api/config-center/store-configs/{location}/force-active/
 * @param {string} location - Store id (e.g. store.location)
 * @returns {Promise} 200: { data: StoreFullConfig }
 */
export function removeForceActiveStore(location) {
  return http.delete(`${storeConfigsUrl(location)}force-active/`);
}

export function getInferenceConfig(hostname) {
  return http.get(inferenceConfigsUrl(), {
    headers: {
      "X-Server-Hostname": hostname,
    },
  });
}
